// client/src/components/layout/MainLayout.tsx
import React from 'react';
import { MarketingHeader } from './MarketingHeader';
import { useAuth } from '../../contexts/AuthContext';
import { Footer } from '../../components/Footer';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';

interface MainLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  showFooter = true 
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen flex flex-col ${
      isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
    }`}>
      <MarketingHeader />
      <main className="flex-grow">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};